class TranslationApi {
    fetchLanguageFile(language) {
        return this.$root.$api.get('/api/public/translation/get', {language}).then(data => {
            this.$store.commit('setTranslations', data);
        });
      }

    setVueRoot($root) {
        this.$root = $root;
        this.$store = $root.$store;
        this.$store.dispatch('setLanguage', {language: this.$store.state.language || this.$store.state.defaultLanguage, changeOnServer: false});
    }

    translate(x) { // Accessible as $translate or window.$translate
        return this.$store.state.translations[x] || x;
    }

    constructor(Vue) {
        this.translations = {};
        Vue.prototype.$translations = this;
        Vue.prototype.$translate = (x) => this.translate(x)
        Vue.filter('translate', (x) => this.translate(x));
        window.$translate = (x) => this.translate(x);
    }
}

export default {
    install(Vue) {
        new TranslationApi(Vue)
    }
}
